import { Box, Typography, Stack } from "@mui/material";

import CustomButton from "../Button/customButton/CustomButton";
import { Selectbox } from "../FormComponent";

const BulkActionsBar = ({ bulkActionsConfig, prefixLabel }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flexStart"
      my={2}
      gap={2}
    >
      {/* Title */}
     {prefixLabel && <Typography 
      sx={
        {
          fontSize: { xl: "16px", md: "14px" }
        }
      }
     fontWeight={500} color="text.secondary">
       {prefixLabel}
      </Typography>}

      {/* Buttons */}
      <Stack direction="row" spacing={2} sx={{minWidth: '180px'}}>
        {bulkActionsConfig.map((item, index) => {
          let type = item.type || "button"   // button select
          if (type === "select") {
            return <Selectbox
              key={index}
              label={item.label}
              options={item.options}
              onChange={item.onChange}
              className={item.className}
              disabled={item.disabled}
              value={item.value}
            />
          }

          return (
            <CustomButton
              key={index}
              variant={item.variant}
              color={item.color}
              startIcon={item.startIcon}
              onClick={item.onClick}
              sx={item.sx}
              disabled={item.disabled}
            >
              {item.label}
            </CustomButton>
          )
        })}
      </Stack>
    </Box>
  );
};

export default BulkActionsBar;
